export default __webpack_public_path__ + "static/media/reward2_detail_step4.39a81a9f.png";